/**
 * @desc 查询单个SKU信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductSkuResponseDto>;
export function request(sku: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productSku/byUnique/sku/${sku}`, {
      method: "GET",

      ...options,
    }),
  );
}
